import { Fragment } from "react";
import { Table } from "react-bootstrap";
import { Eye } from "react-bootstrap-icons";
import Laoder from "../../../components/loading/Loader";
import ServiceInPlaceIcons from "../../../components/shipment/ServiceInPlaceIcons";
import jalaliTime from "../../../functions/jalaliTime";
import useFilterParams from "../../../hooks/useFilterParams";
import useMethodPayment from "../../../hooks/useMethodPayment";
import CompanyEnum from "../../../enums/company/CompanyEnum";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

const TableShipments = ({ data, isFetching, setModalDetails }) => {
  const { getMethodPayment } = useMethodPayment();

  const { getParam } = useFilterParams();

  return (
    <Fragment>
      <article className="mt-5">
        <span>تعداد مرسولات: </span>
        <span className="fs-5 text-success fw-semibold">
          {data.count.toLocaleString()}
        </span>
      </article>

      <div className="w-100 px-1 mt-2 overflow-x-auto">
        <Table bordered striped className="align-middle text-center">
          <thead>
            <tr>
              <th></th>
              <th>شماره سفارش</th>
              <th>ثبت کننده</th>
              <th>تاریخ</th>
              <th>سرویس دهنده</th>
              <th>بارکد</th>
              <th>فرستنده</th>
              <th>گیرنده</th>
              <th>نوع پرداخت</th>
              <th>مبلغ فاکتور</th>
              <th>خدمات در محل</th>
              <th>جزئیات</th>
              <th>وضعیت</th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="13">
                  <Laoder />
                </td>
              </tr>
            )}
            {!isFetching &&
              data.items.map((item, idx) => (
                <tr key={item.id}>
                  <td>
                    {idx + 1 + (getParam("page") - 1) * getParam("items")}
                  </td>
                  <td>
                    <PrintLink ids={[item.id]}>{item.numberParcel}</PrintLink>
                  </td>
                  <td style={{ minWidth: 120 }}>
                    <span>{item.user.name}</span>
                    <span> {item.user.family ?? ""}</span>
                  </td>
                  <td>{jalaliTime(item.created_at).full}</td>
                  <td>{CompanyEnum[item.componyId]}</td>
                  <td>{item.barcode}</td>
                  <td>
                    <span>{item.source.province.faName}</span>
                    <span> {item.source.city.faName} - </span>
                    <span>
                      {item.source.family ? (
                        <span>
                          {item.source.name + " " + item.source.family}
                        </span>
                      ) : (
                        <span>{item.source.compony}</span>
                      )}
                    </span>
                  </td>
                  <td>
                    <span>{item.destination.province.faName}</span>
                    <span> {item.destination.city.faName} - </span>
                    <span>
                      {item.destination.family ? (
                        <span>
                          {item.destination.name +
                            " " +
                            item.destination.family}
                        </span>
                      ) : (
                        <span>{item.destination.compony}</span>
                      )}
                    </span>
                  </td>
                  <td>{getMethodPayment(item.isCod, item.amountCOD)}</td>
                  <td>
                    {(item.realPayable + item.amountCOD).toLocaleString()}
                  </td>
                  <td>
                    <ServiceInPlaceIcons shipment={item} />
                  </td>
                  <td>
                    <button
                      className="buttonUi"
                      onClick={() => setModalDetails(item)}
                    >
                      <Eye color="#4B1483" title="مشاهده جزئیات فاکتور" />
                    </button>
                  </td>
                  <td>
                    {item.status === "تحویل داده شده"
                      ? "تحویل سرویس دهنده"
                      : item.status}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default TableShipments;
